const TextInput = ({ type = 'text', variant, onchange, value, placeholder, pattern, readonly = false, ref = null, required = false, Before, After }) => {
  const className = 'txtinput ' + (variant ?? '');
  const wrapperClassName = 'txtwrapper ' + (variant ?? '');
  return (
    <div className={wrapperClassName}>
      {Before && <Before className="before" />}
      { readonly ? 
      <div className={className}>{ value }</div> :
      <input
        type={type}
        onChange={onchange}
        value={value}
        className={className}
        placeholder={placeholder}
        pattern={pattern}
        readOnly={readonly}
        ref={ref}
        required={required}
      /> }
      {After && <After className="after" />}
    </div>
  )
}

export default TextInput;